import { Module } from "vuex";
import { RootState } from "@/stores";
import * as actions from "./actions";
import mutations from "./mutations";
import { MerchantListItem } from "@/types";

export interface MerchantState {
  merchantList: MerchantListItem[];
}

export const getInitialState = (): MerchantState => ({
  merchantList: [],
});

const initialState: MerchantState = getInitialState();

const pay: Module<MerchantState, RootState> = {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};

export default pay;
